import React, { FC, Suspense, PropsWithChildren, lazy } from 'react'
const WardrunaTheme = lazy(() => import('./WardrunaTheme'))
import FullPageLoader from '../../components/full-page-loader/FullPageLoader'
import { WardrunaStateProvider } from './useWardrunaStore'
import { WardrunaI } from '../../custom-hooks/usePageDataJson'

interface WardrunaPropsI {
  initialState: WardrunaI
}
// TODO: create pages programmatically by wraping wardruna template over all the node returned
const Wardruna: FC<PropsWithChildren<WardrunaPropsI>> = ({
  initialState,
  children,
}: PropsWithChildren<WardrunaPropsI>) => {
  const isSSR = typeof window === 'undefined'

  return (
    <React.Fragment>
      {!isSSR && (
        <Suspense fallback={<FullPageLoader />}>
          <WardrunaStateProvider initialState={initialState}>
            <WardrunaTheme>{children}</WardrunaTheme>
          </WardrunaStateProvider>
        </Suspense>
      )}
    </React.Fragment>
  )
}

export default Wardruna
